import { render } from "./InventoriesReportView.vue?vue&type=template&id=7541ee64"
import script from "./InventoriesReportView.vue?vue&type=script&lang=js"
export * from "./InventoriesReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__